import { useQuery } from '@tanstack/react-query';

import { LitigationAPI } from './models/LitigationAPI';
import { LitigationEntity } from '../entities/LitigationEntity';
import useImperativeRequestWrapper from '@/hooks/useImperativeRequestWrapper';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

const getLitigations = async ({
  shipmentIds,
  makeRequest,
}: {
  shipmentIds: string[];
  makeRequest: any;
}): Promise<LitigationEntity[]> => {
  const { data, error } = await makeRequest({
    path: '/shipments/litigations',
    method: 'POST',
    body: {
      shipment_ids: shipmentIds,
    },
  });

  if (error) throw new Error(error);

  return data.litigations.map((litigation: LitigationAPI) =>
    LitigationEntity.create(litigation)
  );
};

type QueryFnType = typeof getLitigations;

type UseGetLitigations = {
  config?: QueryConfig<QueryFnType>;
  shipmentIds: string[];
  enabled: boolean;
};

export const useGetLitigations = ({
  config,
  shipmentIds,
  enabled = true,
}: UseGetLitigations) => {
  const [, makeRequest] = useImperativeRequestWrapper('shipmentV3');

  return useQuery<ExtractFnReturnType<any>>({
    ...config,
    queryKey: ['litigations', shipmentIds],
    queryFn: () => getLitigations({ shipmentIds, makeRequest }),
    enabled: enabled && shipmentIds.length > 0,
  });
};
